import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";
import { useCart } from "../contexts/CartContext";

const ITEMS_ID = [
  { to: "/", label: "Beranda", testid: "pillnav-home" },
  { to: "/memory-bouquet/create", label: "Memory", testid: "pillnav-memory" },
  { to: "/catalog", label: "Bouquet", testid: "pillnav-bouquet" },
  { to: "/about", label: "Tentang", testid: "pillnav-about" }
];
const ITEMS_EN = [
  { to: "/", label: "Home", testid: "pillnav-home" },
  { to: "/memory-bouquet/create", label: "Memory", testid: "pillnav-memory" },
  { to: "/catalog", label: "Bouquet", testid: "pillnav-bouquet" },
  { to: "/about", label: "About", testid: "pillnav-about" }
];

export default function FloatingPillNav({ cartCount = 0 }) {
  const loc = useLocation();
  const { language, toggleLang } = useLanguage();
  const { openCartDrawer } = useCart();
  const items = language === "id" ? ITEMS_ID : ITEMS_EN;

  return (
    <nav className="pill-nav" data-testid="floating-pill-nav" aria-label="Primary">
      {items.map((item) => {
        const active = item.to === "/" ? loc.pathname === "/" : loc.pathname.startsWith(item.to);
        return (
          <NavLink
            key={item.to}
            to={item.to}
            data-testid={item.testid}
            data-magnet
            className={`pill-nav__item ${active ? "pill-nav__item--active" : ""}`}
          >
            {item.label}
          </NavLink>
        );
      })}
      <button
        onClick={openCartDrawer}
        data-testid="pillnav-cart"
        data-magnet
        className="pill-nav__item relative"
        aria-label="Open cart"
      >
        <ShoppingBag size={14} />
        {cartCount > 0 && (
          <span
            className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-seikat-lime text-seikat-ink text-[10px] font-medium flex items-center justify-center"
            data-testid="pillnav-cart-count"
          >
            {cartCount}
          </span>
        )}
      </button>
      <button
        onClick={toggleLang}
        data-testid="pillnav-lang-toggle"
        data-magnet
        aria-label="Toggle language"
        className="pill-nav__item font-mono text-[10px] tracking-[0.2em] uppercase text-seikat-bone-muted hover:text-seikat-pink transition-colors"
      >
        {language === "id" ? "ID" : "EN"}
      </button>
    </nav>
  );
}
